import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitopalgharcab() {



const cardData = {
  keyword: " Mumbai to Palghar Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Palghar cab services for travelers planning a convenient trip to this scenic district in Maharashtra. Palghar is known for its peaceful beaches, historic forts, temples, and beautiful countryside landscapes along the Konkan coast. Whether you are planning a relaxing weekend getaway, a beach outing, a family trip, or a cultural tour, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. The road distance from Mumbai to Palghar is approximately 90–110 km depending on the route, making it a perfect short road trip destination. We provide flexible booking options including one-way rides, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, skilled chauffeurs familiar with Konkan routes, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Palghar cab booking.",

topPlaces: [
  {
    title: "Kelva Beach",
    description:
      "Kelva Beach is one of the most beautiful and peaceful beaches in the Palghar district. Known for its long stretch of clean sand, coconut trees, and calm atmosphere, the beach is ideal for relaxation, sunset views, and photography. Visitors often enjoy walking along the shoreline, watching fishing boats, and experiencing the serene coastal environment away from the crowds of big city beaches. The nearby Kelva Fort ruins also add historical charm to the area. Traveling by cab from Mumbai allows visitors to comfortably reach this scenic beach and spend quality time enjoying the refreshing sea breeze and natural beauty."
  },
  {
    title: "Shirgaon Fort",
    description:
      "Shirgaon Fort is a historic sea fort located near Palghar and is known for its strong stone walls and coastal location. The fort was originally built during the Portuguese period and later came under Maratha control. Visitors exploring the fort can admire its watchtowers, bastions, and scenic surroundings overlooking the Arabian Sea. History enthusiasts and photographers often visit this site to learn about the region’s maritime past. A comfortable cab journey from Mumbai makes it easy for travelers to explore this heritage attraction while enjoying the coastal landscape."
  },
  {
    title: "Kelve Mahim Fort",
    description:
      "Kelve Mahim Fort is a historic fort located near Kelva Beach and is believed to have been constructed during the medieval period. The fort once served as an important defensive structure along the Konkan coast. Today, visitors explore the remaining walls and ruins while enjoying panoramic views of the nearby sea and surrounding greenery. The peaceful environment makes it a pleasant place for sightseeing and photography. A cab trip from Mumbai allows travelers to conveniently include this historic site in their Palghar tour."
  },
  {
    title: "Tansa Wildlife Sanctuary",
    description:
      "Tansa Wildlife Sanctuary is a lush forest reserve located near Palghar and is known for its rich biodiversity and scenic natural landscapes. The sanctuary is home to several wildlife species including deer, leopards, wild boars, and numerous birds. Nature lovers and wildlife enthusiasts enjoy exploring the forest trails and observing the region’s diverse flora and fauna. The nearby Tansa Lake also adds to the beauty of the area. Traveling by cab from Mumbai provides a comfortable way to visit this peaceful natural attraction and experience the beauty of Maharashtra’s forests."
  },
  {
    title: "Jivdani Temple",
    description:
      "Jivdani Temple is a famous hilltop temple located near Virar in the Palghar district and is dedicated to Goddess Jivdani. The temple attracts thousands of devotees who climb hundreds of steps to reach the shrine and seek blessings. From the top of the hill, visitors can enjoy breathtaking panoramic views of the surrounding landscape and nearby towns. The temple is particularly busy during festivals and Navratri celebrations. Booking a cab from Mumbai allows devotees to comfortably travel to the temple and complete their pilgrimage journey."
  },
  {
    title: "Chinchani Beach",
    description:
      "Chinchani Beach is a quiet and less crowded beach located near the Maharashtra-Gujarat border in the Palghar district. The beach is known for its calm environment, beautiful sunsets, and peaceful coastal scenery. Visitors enjoy walking along the shore, watching local fishing activities, and relaxing away from busy tourist areas. The surrounding villages also offer a glimpse into the traditional coastal lifestyle of the Konkan region. A cab ride from Mumbai allows travelers to conveniently explore this hidden beach destination."
  },
  {
    title: "Mahim Beach (Palghar)",
    description:
      "Mahim Beach in Palghar is a scenic coastal destination known for its tranquil surroundings and wide sandy shoreline. The beach is ideal for evening walks, relaxation, and photography, especially during sunset when the sky reflects beautiful colors over the sea. Local fishing boats and traditional coastal villages add cultural charm to the area. Visitors traveling by cab from Mumbai can easily include Mahim Beach in their Palghar sightseeing trip while enjoying a relaxing coastal drive."
  },
  {
    title: "Satpati Beach",
    description:
      "Satpati Beach is a beautiful fishing village beach located near Palghar and is famous for its large fishing harbor. Visitors often come here to observe the busy fishing activities, colorful boats, and the daily life of local fishermen. The beach offers scenic views of the Arabian Sea and a peaceful atmosphere for relaxation. It is also an excellent place for photography and experiencing the authentic coastal culture of Maharashtra. Traveling by cab from Mumbai allows tourists to comfortably visit this unique seaside destination."
  },
  {
    title: "Kohoj Fort",
    description:
      "Kohoj Fort is an ancient hill fort located near Palghar and is a popular trekking destination for adventure enthusiasts. The fort stands at a high elevation and offers spectacular views of the surrounding forests, hills, and valleys. The trek to the fort passes through scenic landscapes and is suitable for beginners as well as experienced trekkers. Visitors enjoy the combination of history, nature, and adventure at this destination. A cab journey from Mumbai makes it convenient for travelers to reach the base village and begin the trek."
  },
  {
    title: "Waghoba Waterfall",
    description:
      "Waghoba Waterfall is a beautiful seasonal waterfall located in the forested region of Palghar district. The waterfall becomes especially attractive during the monsoon season when water flows powerfully through the rocky terrain surrounded by lush greenery. Visitors enjoy nature walks, photography, and relaxing in the cool natural environment near the waterfall. It is an excellent spot for short trips and monsoon outings. Traveling by cab from Mumbai allows visitors to comfortably explore this refreshing natural attraction."
  }
],



services: [
{
name: "Mumbai to Palghar Cab",
description: "Mumbai to Palghar cab service provides comfortable and reliable transportation for travelers heading from Mumbai to the coastal district of Palghar. The route is frequently used for business visits, family trips, and tourism travel to nearby beaches and resorts. Our vehicles are well-maintained and suitable for short highway journeys with comfortable seating and luggage space. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Air-conditioned vehicles ensure relaxed travel throughout the journey. Ideal for daily commuters, family visits, and weekend trips. Flexible booking options allow convenient ride scheduling."
},
{
name: "Mumbai to Palghar Taxi",
description: "Mumbai to Palghar taxi service offers dependable intercity transportation between Mumbai and Palghar district. Vehicles provide smooth ride quality and comfortable seating suitable for highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism visits, business travel, and family journeys. Air-conditioned vehicles ensure comfortable travel experiences. Flexible taxi booking options allow passengers to easily schedule their rides."
},
{
name: "Mumbai to Palghar Cab Service",
description: "Mumbai to Palghar cab service offers reliable transportation for travelers visiting Palghar for work, family visits, or leisure travel. Vehicles are designed for highway journeys and provide comfortable seating for passengers and luggage. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for daily travel, business trips, and tourism visits to nearby beaches and resorts."
},
{
name: "Mumbai to Palghar Taxi Service",
description: "Mumbai to Palghar taxi service provides convenient travel options for passengers traveling between the two cities. Vehicles provide smooth ride performance and spacious seating suitable for comfortable road travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family visits, tourism travel, and corporate journeys."
},
{
name: "Cab from Mumbai to Palghar",
description: "Cab from Mumbai to Palghar offers comfortable and reliable transportation for travelers planning short-distance intercity journeys. Vehicles provide comfortable seating and smooth ride quality suitable for highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for daily travel, family trips, and tourism visits."
},
{
name: "Taxi from Mumbai to Palghar",
description: "Taxi from Mumbai to Palghar provides dependable travel options for passengers visiting Palghar for business meetings, family trips, or tourism travel. Vehicles provide smooth highway performance and comfortable seating suitable for the journey. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals."
},
{
name: "Mumbai to Palghar Cab Booking",
description: "Mumbai to Palghar cab booking allows travelers to easily reserve vehicles for convenient intercity transportation. Online and phone booking options provide instant confirmation and flexible ride scheduling. Vehicles offer comfortable seating and reliable performance for highway travel. Professional drivers ensure punctual pickup services across Mumbai."
},
{
name: "Mumbai to Palghar Taxi Booking Online",
description: "Mumbai to Palghar taxi booking online provides quick and convenient digital reservations for passengers planning intercity travel. Travelers can schedule their ride and receive instant booking confirmation. Vehicles provide comfortable seating and smooth highway performance suitable for daily travel."
},
{
name: "Mumbai to Palghar Cab Price",
description: "Mumbai to Palghar cab price options provide transparent fare estimates for travelers planning intercity journeys. Pricing depends on vehicle category, distance, and travel duration. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size."
},
{
name: "Mumbai to Palghar Taxi Fare",
description: "Mumbai to Palghar taxi fare services offer flexible pricing options depending on vehicle type and travel duration. Passengers can choose economical sedans or spacious SUVs depending on travel preferences."
},
{
name: "Mumbai to Palghar One Way Cab",
description: "Mumbai to Palghar one way cab service provides economical transportation without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for quick intercity journeys."
},
{
name: "Mumbai to Palghar Round Trip Taxi",
description: "Mumbai to Palghar round trip taxi service provides convenient transportation for passengers planning return journeys the same day or later. Vehicles provide comfortable seating and reliable travel for both directions."
},
{
name: "Mumbai to Palghar Innova Cab",
description: "Mumbai to Palghar Innova cab service provides spacious MPV transportation ideal for families and small groups traveling comfortably. The Toyota Innova offers comfortable seating and smooth highway performance."
},
{
name: "Mumbai to Palghar Ertiga Cab",
description: "Mumbai to Palghar Ertiga cab service offers comfortable MPV transportation suitable for family travel and small groups. The Maruti Ertiga provides spacious seating and smooth ride quality."
},
{
name: "Mumbai to Palghar Sedan Cab",
description: "Mumbai to Palghar sedan cab service provides economical and comfortable transportation for passengers traveling between Mumbai and Palghar. Sedan vehicles offer smooth ride quality and comfortable seating for business or family travel."
}
],

tableData: [
["Mumbai to Palghar Cab","Mumbai to Palghar Taxi"],
["Mumbai to Palghar Cab Service","Mumbai to Palghar Taxi Service"],
["Cab from Mumbai to Palghar","Taxi from Mumbai to Palghar"],
["Mumbai to Palghar Cab Booking","Mumbai to Palghar Taxi Booking Online"],
["Mumbai to Palghar Cab Price","Mumbai to Palghar Taxi Fare"],
["Mumbai to Palghar One Way Cab","Mumbai to Palghar Round Trip Taxi"],
["Mumbai to Palghar Innova Cab","Mumbai to Palghar Ertiga Cab"],
["Mumbai to Palghar Sedan Cab","Palghar Taxi from Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Local Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving from Mumbai to Palghar. They are familiar with local highways, coastal roads, and traffic conditions, ensuring a safe and smooth journey for passengers."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Palghar cab bookings. Customers receive clear details about per-kilometer charges, toll fees, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Palghar cab service operates 24 hours a day. Whether you want to travel early morning, during the day, or late at night, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and same-day return packages from Mumbai to Palghar."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Palghar journey begins smoothly."
  },
  {
    WhyChooseheading: "Reliable Local Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for reliable local cab services. Our punctual drivers, comfortable vehicles, and professional service ensure a stress-free journey from Mumbai to Palghar."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Palghar?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Palghar for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Palghar?", answer: "The distance from Mumbai to Palghar is approximately 90 km and the journey usually takes around 2 to 3 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Mumbai to Palghar?", answer: "Yes, we offer both one-way and round-trip cab services between Mumbai and Palghar." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Palghar cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or sightseeing." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Palghar." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Desai",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Palghar trip. The driver was punctual and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Excellent cab service. Clean car, polite driver, and smooth travel from Mumbai to Palghar.",
    rating: 5
  }
];










































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Palghar Cab",
  "description": "Omshree Cab offers reliable cab services from Mumbai to Palghar for one-way trips, round trips, and corporate or family travel. Travel safely and comfortably with well-maintained vehicles like Innova, Ertiga, and Sedan. Flexible booking options and transparent pricing make your journey hassle-free.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "920"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mumbai to Palghar Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides cab services from Mumbai to Palghar for one-way trips, round trips, family, and corporate travel. Travel safely with Innova, Ertiga, or Sedan. Flexible bookings and transparent pricing for hassle-free journeys." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopalgharcab;